import { useState, useEffect } from "react";
import { CDBSidebarMenu } from "cdbreact";
import { NavLink } from "react-router-dom";
import {
  Avatar,
  CardHeader,
  Collapse,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LineAxisIcon from "@mui/icons-material/LineAxis";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import HistoryIcon from "@mui/icons-material/History";
import TroubleshootIcon from "@mui/icons-material/Troubleshoot";
import CampaignIcon from "@mui/icons-material/Campaign";
import SettingsIcon from "@mui/icons-material/Settings";
import EngineeringIcon from "@mui/icons-material/Engineering";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import CameraOutdoorIcon from "@mui/icons-material/CameraOutdoor";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu1 from "@mui/material/Menu";
import { RUTA_IMG, version } from "../componentes/config";
import NoFoto from "../assets/noFoto.jpg";
import { sql } from "../componentes/api";

const ITEM_HEIGHT = 48;

const Menu = (props) => {
  const [openPara, setOpenPara] = useState(true);
  const [fileDataURL, setFileDataURL] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    {
      props.Foto !== ""
        ? setFileDataURL(RUTA_IMG + "fotos/" + props.Foto)
        : setFileDataURL(NoFoto);
    }
  }, [props.Foto]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event, idMenu) => {
    event.preventDefault();
    setAnchorEl(null);
  };

  const paraClick = () => {
    setOpenPara(!openPara);
  };

  const cerrarSesion = (event) => {
    event.preventDefault();
    const resp = sql("updateConexion", "PUT", {
      NumIngresos: null,
      Id: props.Id,
      Socket: props.Socket.id,
    });
    props.cerrarSesion();
  };

  return (
    <div className="container">
      <div className="row">
        <CardHeader
          avatar={<Avatar src={fileDataURL} />}
          action={
            <IconButton
              aria-label="more"
              id="long-button"
              aria-controls={open ? "long-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MoreVertIcon />
            </IconButton>
          }
          title={props.Nbres}
        />
      </div>

      <div className="row">
        <h6 className="text-center">
          Ecosistema Versión:{" "}
          <span className="badge text-bg-secondary">{version}</span>
        </h6>
        <button
          className="btn btn-primary"
          onClick={(event) => cerrarSesion(event)}
        >
          <span> Salir (Log Out)</span>
        </button>
      </div>
      <hr />

      <div className="row">
        <List
          sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          <Menu1
            id="long-menu"
            MenuListProps={{
              "aria-labelledby": "long-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: "20ch",
              },
            }}
          >
            <CDBSidebarMenu>
              <NavLink exact="true" to="/foto">
                <ListItemButton>
                  <ListItemText primary="Cambiar Foto" />
                </ListItemButton>
              </NavLink>
            </CDBSidebarMenu>
          </Menu1>

          <CDBSidebarMenu>
            <NavLink exact="true" to="/dash">
              <ListItemButton>
                <ListItemIcon>
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="Dashboard" />
              </ListItemButton>
            </NavLink>

            <NavLink exact="true" to="/proyectos">
              <ListItemButton>
                <ListItemIcon>
                  {" "}
                  <LineAxisIcon />{" "}
                </ListItemIcon>
                <ListItemText primary="Proyectos" />
              </ListItemButton>
            </NavLink>

            <NavLink exact="true" to="/seguimiento">
              <ListItemButton>
                <ListItemIcon>
                  {" "}
                  <TroubleshootIcon />{" "}
                </ListItemIcon>
                <ListItemText primary="Seguimiento" />
              </ListItemButton>
            </NavLink>

            <NavLink exact="true" to="/historico">
              <ListItemButton>
                <ListItemIcon>
                  <HistoryIcon />
                </ListItemIcon>
                <ListItemText primary="Histórico" />
              </ListItemButton>
            </NavLink>

            <NavLink exact="true" to="/chat">
              <ListItemButton>
                <ListItemIcon>
                  <WhatsAppIcon />
                </ListItemIcon>
                <ListItemText primary="Chat" />
              </ListItemButton>
            </NavLink>

            <NavLink exact="true" to="/foro">
              <ListItemButton>
                <ListItemIcon>
                  <RecordVoiceOverIcon />
                </ListItemIcon>
                <ListItemText primary="Foro" />
              </ListItemButton>
            </NavLink>

            <NavLink exact="true" to="/sala">
              <ListItemButton>
                <ListItemIcon>
                  <CameraOutdoorIcon />
                </ListItemIcon>
                <ListItemText primary="Salas de Reunión" />
              </ListItemButton>
            </NavLink>

            <NavLink exact="true" to="/analitica">
              <ListItemButton>
                <ListItemIcon>
                  <TroubleshootIcon />
                </ListItemIcon>
                <ListItemText primary="Analítica" />
              </ListItemButton>
            </NavLink>

            <NavLink exact="true" to="/alertas">
              <ListItemButton>
                <ListItemIcon>
                  <CampaignIcon />
                </ListItemIcon>
                <ListItemText primary="Alertas" />
              </ListItemButton>
            </NavLink>

            <ListItemButton onClick={paraClick}>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Parametros" />
              {openPara ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openPara} timeout="auto" unmountOnExit>
              <NavLink exact="true" to="/cargos">
                <List component="div" disablePadding>
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon>
                      <EngineeringIcon />
                    </ListItemIcon>
                    <ListItemText primary="Componentes" />
                  </ListItemButton>
                </List>
              </NavLink>

              <NavLink exact="true" to="/aportantes">
                <List component="div" disablePadding>
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon>
                      <AccountBalanceIcon />
                    </ListItemIcon>
                    <ListItemText primary="Empresas Aportantes" />
                  </ListItemButton>
                </List>
              </NavLink>

              <NavLink exact="true" to="/familiaridad">
                <List component="div" disablePadding>
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon>
                      <FamilyRestroomIcon />
                    </ListItemIcon>
                    <ListItemText primary="Familiaridad" />
                  </ListItemButton>
                </List>
              </NavLink>

              <NavLink exact="true" to="/foroTemas">
                <List component="div" disablePadding>
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon>
                      <FamilyRestroomIcon />
                    </ListItemIcon>
                    <ListItemText primary="Temas de Foros" />
                  </ListItemButton>
                </List>
              </NavLink>

              <NavLink exact="true" to="/poblacion">
                <List component="div" disablePadding>
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon>
                      <Diversity3Icon />
                    </ListItemIcon>
                    <ListItemText primary="Tipo de Población" />
                  </ListItemButton>
                </List>
              </NavLink>

              <NavLink exact="true" to="/tipodocumento">
                <List component="div" disablePadding>
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon>
                      <CreditScoreIcon />
                    </ListItemIcon>
                    <ListItemText primary="Tipos de Documentos" />
                  </ListItemButton>
                </List>
              </NavLink>
            </Collapse>
          </CDBSidebarMenu>
        </List>
      </div>
    </div>
  );
};

export default Menu;
